import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Container, Row, Col } from 'react-bootstrap';
import './FilterModal.css'
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import { GetBenefitLookupList, GetDeityLookupList } from '../../ApiServices/Benefit/BenefitApi';
import { CityLookupList } from '../../ApiServices/Other/StateLookupListApi';
import { LoaderContext } from '../../AuthContext/AuthContext';
import { GetTempleCityList } from '../../ApiServices/Temple/TempleApi';
import { t } from 'i18next';

// Dummy data for filter options
const locationOptions = [
    { name: 'Bihar', image: pandit },
    { name: 'Madhya Pradesh', image: pandit },
    { name: 'Maharashtra', image: pandit },
    { name: 'Nepal', image: pandit },
    { name: 'Uttar Pradesh', image: pandit },
    { name: 'Uttarakhand', image: pandit },
];

// Reusable FilterCard component
// Reusable FilterCard component
const FilterCard = ({ option, isSelected, onSelect }) => (
    <div
        className={`filter-card-text ${isSelected ? "selected" : ""}`}
        onClick={() => onSelect(option.value)}
    >
        <input
            type="checkbox"
            checked={isSelected}
            onChange={() => { }}
            className="filter-checkbox-input"
        />
        <span className="filter-card-label-text ">{option.label}</span>
    </div>
);


const FilterModal = ({ show, onHide, onConfirm, modelRequestData, setModelRequestData, setIsFilterApplied }) => {
    const { setLoader, isLanguageUpdate, selectedLanguageID } = useContext(LoaderContext);

    const [activeCategory, setActiveCategory] = useState(null);
    const [selectedLocations, setSelectedLocations] = useState(modelRequestData?.selectedLocations || []);
    const [selectedDeity, setSelectedDeity] = useState(modelRequestData?.selectedDeity || []);
    const [selectedBenefits, setSelectedBenefits] = useState(modelRequestData?.selectedBenefits || []);
    const [benefitOptions, setBenefitOptions] = useState([])
    const [locationOptions, setLocationOptions] = useState([])
    const [deityOptions, setDeityOptions] = useState([])

    useEffect(() => {
        if (show) {
            GetBenefitLookupListData()
            GetTempleCityListData()
            GetDeityLookupListData()
            setActiveCategory(modelRequestData?.category)
        }
    }, [show])

    const GetBenefitLookupListData = async () => {

        try {
            const response = await GetBenefitLookupList(Number(selectedLanguageID));
            if (response?.statusCode == 200) {
                const data = response.responseData.data || []; // Assuming the data is an array and we need the first item
                const formatted = data.map(item => ({
                    value: item.benefitID,
                    label: item.benefitName
                }));

                setBenefitOptions(formatted);

            } else {
                // setLoader(false);

                console.error(
                    "Error fetching data: ",
                    response.responseData.statusCode
                );
            }
        } catch (error) {
            // setLoader(false);

            console.error("Error", error);
        }
    };
    const GetDeityLookupListData = async () => {

        try {
            const response = await GetDeityLookupList(Number(selectedLanguageID));
            if (response?.statusCode == 200) {
                const data = response.responseData.data || []; // Assuming the data is an array and we need the first item
                const formatted = data.map(item => ({
                    value: item.deityID,
                    label: item.deityName
                }));

                setDeityOptions(formatted);

            } else {
                // setLoader(false);

                console.error(
                    "Error fetching data: ",
                    response.responseData.statusCode
                );
            }
        } catch (error) {
            // setLoader(false);

            console.error("Error", error);
        }
    };

    const GetTempleCityListData = async () => {
        setLoader(true);
        try {
            const response = await GetTempleCityList(Number(selectedLanguageID));


            if (response?.statusCode === 200) {
                const responseData = response?.responseData?.data || [];
                const formattedLangList = responseData.map((Lang) => ({
                    value: Lang.districtID,
                    label: Lang.districtName,
                }));

                setLocationOptions(formattedLangList);
            } else {
                console.error("Unexpected response:", response);
            }
        } catch (error) {
            console.error("Error fetching temple city list:", error);
        } finally {
            setLoader(false);
        }
    };

    const handleSelectLocation = (locationName) => {

        if (activeCategory === 'Benefits') {
            setSelectedBenefits(prevSelected =>
                prevSelected.includes(locationName)
                    ? prevSelected.filter(value => value !== locationName)
                    : [...prevSelected, locationName]
            );
        } else if (activeCategory === 'Location') {
            setSelectedLocations(prevSelected =>
                prevSelected.includes(locationName)
                    ? prevSelected.filter(value => value !== locationName)
                    : [...prevSelected, locationName]
            );
        } else if (activeCategory === 'Deity') {
            setSelectedDeity(prevSelected =>
                prevSelected.includes(locationName)
                    ? prevSelected.filter(value => value !== locationName)
                    : [...prevSelected, locationName]
            );
        }

    };

    const handleApply = () => {

        let totalCount = 0
        if (selectedBenefits?.length > 0 && selectedDeity?.length > 0 && selectedLocations?.length > 0) {
            totalCount = 3
        } else if ((selectedBenefits?.length === 0 && selectedDeity?.length > 0 && selectedLocations?.length > 0) || (selectedBenefits?.length > 0 && selectedDeity?.length === 0 && selectedLocations?.length > 0) || (selectedBenefits?.length > 0 && selectedDeity?.length > 0 && selectedLocations?.length === 0)) {
            totalCount = 2
        } else if ((selectedBenefits?.length > 0 || selectedDeity?.length > 0 || selectedLocations?.length > 0)) {
            totalCount = 1
        }
        setModelRequestData(prevData => ({ ...prevData, selectedLocations: selectedLocations, selectedBenefits: selectedBenefits, selectedDeity: selectedDeity, selectedCount: totalCount }));
        setIsFilterApplied(true)
        onHide()
    };

    const handleClear = () => {
        setSelectedLocations([]);
        setSelectedBenefits([])
        setSelectedDeity([])
    };


    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            size='lg'
            centered

        >
            <Modal.Header closeButton>
                <Modal.Title className="fw-bold fs-4">{t("Filter")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex p-0" >
                <div className='d-flex w-100' style={{ minHeight: '60vh' }}>
                    <aside className="filter-sidebar">
                        <div
                            className={`filter-category ${activeCategory === 'Location' ? 'active' : ''}`}
                            onClick={() => setActiveCategory('Location')}
                        >
                            {t("Location")}
                            {selectedLocations?.length > 0 && (
                                <span className="badge ms-2" style={{ backgroundColor: "#a52444" }}>
                                    {selectedLocations.length}
                                </span>
                            )}
                        </div>

                        <div
                            className={`filter-category ${activeCategory === 'Benefits' ? 'active' : ''}`}
                            onClick={() => setActiveCategory('Benefits')}
                        >
                            {t("Benefits")}
                            {selectedBenefits?.length > 0 && (
                                <span className="badge ms-2" style={{ backgroundColor: "#a52444" }}>
                                    {selectedBenefits.length}
                                </span>
                            )}
                        </div>
                        <div
                            className={`filter-category ${activeCategory === 'Deity' ? 'active' : ''}`}
                            onClick={() => setActiveCategory('Deity')}
                        >
                            {t("Deity")}
                            {selectedDeity?.length > 0 && (
                                <span className="badge ms-2" style={{ backgroundColor: "#a52444" }}>
                                    {selectedDeity.length}
                                </span>
                            )}
                        </div>
                    </aside>
                    <div className=" gap-1" style={{ maxHeight: '60vh', overflow: "auto", width: '100%' }}>
                        {activeCategory === 'Location' && (


                            locationOptions.map(option => (
                                <div key={option.value}>
                                    <FilterCard
                                        option={option}
                                        isSelected={selectedLocations.includes(option.value)}
                                        onSelect={handleSelectLocation}
                                    />
                                </div>
                            ))

                        )}
                        {activeCategory === 'Benefits' && (


                            benefitOptions?.map(option => (
                                <div key={option.value}>
                                    <FilterCard
                                        option={option}
                                        isSelected={selectedBenefits.includes(option.value)}
                                        onSelect={handleSelectLocation}
                                    />
                                </div>
                            ))

                        )}
                        {activeCategory === 'Deity' && (


                            deityOptions?.map(option => (
                                <div key={option.value}>
                                    <FilterCard
                                        option={option}
                                        isSelected={selectedDeity.includes(option.value)}
                                        onSelect={handleSelectLocation}
                                    />
                                </div>
                            ))

                        )}

                    </div>


                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-end p-3">
                <Button variant="outline-secondary" onClick={handleClear}>
                    Clear
                </Button>
                <Button className="btn-apply-filter" onClick={handleApply}>
                    Apply
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FilterModal;
